/* AJAX add to cart and slide in cart drawer.
   Rendered by snippets/sp-ajax-cart.liquid, which is included once from
   layout/theme.liquid. A .js.liquid asset rather than an inline script so the
   browser can cache it, and because the translations below need Liquid. */
(function () {
  if (window.spAjaxCartReady) { return; }
  window.spAjaxCartReady = true;

  var drawer = document.getElementById('spDrawer');
  var overlay = document.getElementById('spDrawerOverlay');
  var bodyEl = document.getElementById('spDrawerBody');
  var footEl = document.getElementById('spDrawerFoot');
  var countEl = document.getElementById('spDrawerCount');
  var closeBtn = document.getElementById('spDrawerClose');
  var toastEl = document.getElementById('spToast');
  var toastTimer = null;
  var lastFocus = null;

  if (!drawer || !overlay || !bodyEl || !footEl) { return; }

  /* Translations are piped through the json filter rather than dropped into a
     quoted JS string. A merchant can edit any of these in the admin language
     editor, and one apostrophe would otherwise break the whole script. */
  var T = {
    empty: "Your cart is currently empty!",
    continueShopping: "Continue shopping",
    subtotal: "Subtotal",
    shippingNote: "Shipping, taxes, and discounts will be calculated at checkout.",
    checkout: "Check Out",
    viewCart: "View Cart",
    remove: "Remove"
  };

  function formatMoney(cents) {
    if (window.Shopify && typeof window.Shopify.formatMoney === 'function' && window.money_format) {
      try { return window.Shopify.formatMoney(cents, window.money_format); } catch (e) {}
    }
    return 'Rs.' + (cents / 100).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  }

  function esc(value) {
    var d = document.createElement('div');
    d.textContent = value == null ? '' : value;
    return d.innerHTML;
  }

  function toast(message, isError) {
    if (!toastEl) { return; }
    toastEl.textContent = message;
    toastEl.className = 'sp-toast is-visible' + (isError ? ' is-error' : '');
    if (toastTimer) { clearTimeout(toastTimer); }
    toastTimer = setTimeout(function () {
      toastEl.className = 'sp-toast' + (isError ? ' is-error' : '');
    }, 2600);
  }

  function lineImage(item) {
    var src = item.image || (item.featured_image && item.featured_image.url) || '';
    if (!src) { return ''; }
    if (src.indexOf('//') === 0) { src = 'https:' + src; }
    return String(src).replace(/(\.[a-zA-Z]+)(\?|$)/, '_120x$1$2');
  }

  function render(cart) {
    var n = cart.item_count;

    var headerCount = document.getElementById('cartCount');
    if (headerCount) { headerCount.textContent = n; }
    if (countEl) { countEl.textContent = n > 0 ? '(' + n + ')' : ''; }

    if (!n) {
      bodyEl.innerHTML =
        '<div class="sp-drawer-empty">' +
          '<p>' + esc(T.empty) + '</p>' +
          '<a class="sp-shop-btn" href="/collections/all">' + esc(T.continueShopping) + '</a>' +
        '</div>';
      footEl.innerHTML = '';
      return cart;
    }

    bodyEl.innerHTML = cart.items.map(function (item) {
      var img = lineImage(item);
      /* the Liquid seed and /cart.js do not always name this field the same */
      var name = item.product_title || item.title || '';
      var variant = '';
      if (item.variant_title && item.variant_title.indexOf('Default') === -1) {
        variant = '<div class="sp-line-variant">' + esc(item.variant_title) + '</div>';
      }
      return '<div class="sp-line" data-key="' + esc(item.key) + '">' +
               '<a class="sp-line-img" href="' + esc(item.url) + '">' +
                 (img ? '<img src="' + esc(img) + '" alt="' + esc(name) + '" loading="lazy">' : '') +
               '</a>' +
               '<div class="sp-line-main">' +
                 '<a class="sp-line-title" href="' + esc(item.url) + '">' + esc(name) + '</a>' +
                 variant +
                 '<div class="sp-line-row">' +
                   '<span class="sp-qty">' +
                     '<button type="button" class="sp-qty-down" aria-label="Decrease quantity">&minus;</button>' +
                     '<span class="sp-qty-val">' + item.quantity + '</span>' +
                     '<button type="button" class="sp-qty-up" aria-label="Increase quantity">+</button>' +
                   '</span>' +
                   '<span class="sp-line-price">' + formatMoney(item.line_price) + '</span>' +
                 '</div>' +
                 '<button type="button" class="sp-line-remove">' + esc(T.remove) + '</button>' +
               '</div>' +
             '</div>';
    }).join('');

    footEl.innerHTML =
      '<div class="sp-subtotal">' +
        '<span class="sp-subtotal-label">' + esc(T.subtotal) + '</span>' +
        '<span class="sp-subtotal-value">' + formatMoney(cart.total_price) + '</span>' +
      '</div>' +
      '<p class="sp-subtotal-note">' + esc(T.shippingNote) + '</p>' +
      '<div class="sp-drawer-actions">' +
        '<button type="button" class="sp-btn sp-btn--primary" id="spCheckout">' + esc(T.checkout) + '</button>' +
        '<a class="sp-btn sp-btn--ghost" href="/cart">' + esc(T.viewCart) + '</a>' +
      '</div>';

    if (window.Currency && typeof window.Currency.convertAll === 'function' && window.shopCurrency && typeof window.currentCurrency !== 'undefined') {
      try { window.Currency.convertAll(window.shopCurrency, window.currentCurrency); } catch (e) {}
    }
    return cart;
  }

  function fetchCart() {
    return fetch('/cart.js', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(render);
  }

  function openDrawer() {
    lastFocus = document.activeElement;
    drawer.classList.add('is-open');
    overlay.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    document.body.classList.add('sp-drawer-open');
    if (closeBtn) { closeBtn.focus(); }
  }

  function closeDrawer() {
    drawer.classList.remove('is-open');
    overlay.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('sp-drawer-open');
    if (lastFocus && typeof lastFocus.focus === 'function') { lastFocus.focus(); }
  }

  function changeLine(key, quantity) {
    return fetch('/cart/change.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
        'X-Requested-With': 'XMLHttpRequest'
      },
      body: 'id=' + encodeURIComponent(key) + '&quantity=' + quantity
    })
      .then(function (r) { return r.json(); })
      .then(render)
      .catch(function () { toast('Could not update cart', true); });
  }

  /* seed from the server rendered cart so the drawer is correct before the
     first fetch, then keep it in sync from /cart.js after every change */
  try {
    var seed = document.getElementById('spCartSeed');
    if (seed) { render(JSON.parse(seed.textContent)); }
  } catch (e) { fetchCart(); }

  overlay.addEventListener('click', closeDrawer);
  if (closeBtn) { closeBtn.addEventListener('click', closeDrawer); }
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && drawer.classList.contains('is-open')) { closeDrawer(); }
  });

  document.addEventListener('click', function (e) {
    if (!e.target.closest) { return; }

    /* header cart icon opens the drawer instead of the theme dropdown */
    var cartIcon = e.target.closest('#ToggleDown, .wrapper-top-cart > a');
    if (cartIcon) {
      e.preventDefault();
      openDrawer();
      fetchCart();
      return;
    }

    if (e.target.closest('#spCheckout')) {
      window.location.href = '/checkout';
      return;
    }

    /* quantity and remove inside the drawer */
    var line = e.target.closest('.sp-line');
    if (line) {
      var key = line.getAttribute('data-key');
      var current = parseInt(line.querySelector('.sp-qty-val').textContent, 10) || 1;
      if (e.target.closest('.sp-qty-up')) { e.preventDefault(); changeLine(key, current + 1); return; }
      if (e.target.closest('.sp-qty-down')) { e.preventDefault(); changeLine(key, Math.max(0, current - 1)); return; }
      if (e.target.closest('.sp-line-remove')) { e.preventDefault(); changeLine(key, 0); return; }
    }
  });

  /* Add to cart, everywhere.

     Hooked to the submit event of any form posting to /cart/add rather than to
     a button class, because this store draws product cards from more than one
     place and each uses its own class: snippets/sp-product-card.liquid uses
     .tb-add, sections/product-grid-cards.liquid uses .pgc-btn, and the Kalles
     sections ship their own markup again. The form is the one thing they all
     share, so hooking it covers the home page, collection pages, search, the
     product page, and any section added later without another edit here.

     Cards whose control is a link to the product page (products with options)
     and sold out spans are left alone, since neither submits a form.

     The request body is the form's own FormData, not a hand built id and
     quantity string, so quantity, line item properties and selling plans all
     survive. Content-Type is deliberately not set: the browser has to add the
     multipart boundary itself. */
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form || form.tagName !== 'FORM') { return; }
    if ((form.getAttribute('action') || '').indexOf('/cart/add') === -1) { return; }

    var data = new FormData(form);
    /* no variant resolved: let the browser post normally rather than failing
       silently, so the customer still ends up somewhere sensible */
    if (!data.get('id')) { return; }

    e.preventDefault();

    var btn = e.submitter || form.querySelector('[type="submit"]');
    if (btn) {
      if (btn.hasAttribute('data-sp-loading')) { return; }
      btn.setAttribute('data-sp-loading', '');
    }
    function settle() { if (btn) { btn.removeAttribute('data-sp-loading'); } }

    fetch('/cart/add.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'X-Requested-With': 'XMLHttpRequest' },
      body: data
    })
      .then(function (r) {
        return r.json().then(function (payload) {
          if (!r.ok) { throw new Error(payload.description || payload.message || 'Could not add to cart'); }
          return payload;
        });
      })
      .then(function () {
        settle();
        openDrawer();
        return fetchCart();
      })
      .catch(function (err) {
        settle();
        toast(err.message || 'Could not add to cart', true);
      });
  });
})();